import moment from 'moment';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useBooking } from '../../../../contexts/ticketBookingContext/TicketBookingContext';
import SearchTitle from '../../search/components/SearchTitle';
import { useAuth } from '../../../../contexts/userContext/userContext';
import useTranslation from '../../../../hooks/translation/useTranslation';

function BookingTitle() {
  const navigate = useNavigate();
  const { currentLanguage } = useTranslation();
  const { bookingData } = useBooking();
  const { ticketBookingOptions } = useAuth();

  const departureStartStation = ticketBookingOptions?.stations?.find(
    (station) => station?.value === bookingData?.departure?.startStation?.code,
  )?.[`label_${currentLanguage}`] || bookingData?.departure?.startStation?.name;

  const departureEndStation = ticketBookingOptions?.stations?.find(
    (station) => station?.value === bookingData?.departure?.endStation?.code,
  )?.[`label_${currentLanguage}`] || bookingData?.departure?.endStation?.name;

  const returnStartStation = ticketBookingOptions?.stations?.find(
    (station) => station?.value === bookingData?.return?.startStation?.code,
  )?.[`label_${currentLanguage}`] || bookingData?.return?.startStation?.name;

  const returnEndStation = ticketBookingOptions?.stations?.find(
    (station) => station?.value === bookingData?.return?.endStation?.code,
  )?.[`label_${currentLanguage}`] || bookingData?.return?.endStation?.name;

  const rides = [{
    id: 1,
    departureDate: moment(
      bookingData?.departure?.startDate,
    ).format('DD.MM.YYYY'),
    stations: `${departureStartStation} - ${departureEndStation}`,
  }];

  if (bookingData?.return?.id) {
    rides.push({
      id: 2,
      departureDate: moment(
        bookingData?.return?.startDate,
      ).format('DD.MM.YYYY'),
      stations: `${returnStartStation} - ${returnEndStation}`,
    });
  }
  return (
    <div className="flex gap-5">
      <div className="h-8 flex items-center">
        <ArrowLeftOutlined
          style={{ color: 'var(--primary-color)', fontSize: '20px' }}
          onClick={async () => {
            if (window.history.length >= 1) {
              await window.history.back();
            } else {
              navigate('/ka/search');
            }
          }}
        />
      </div>
      <div className="flex flex-col gap-1">
        {
          rides?.map(({ departureDate, stations, id }) => (
            <SearchTitle
              key={id}
              rideStations={stations}
              date={departureDate}
            />
          ))
      }
      </div>
    </div>
  );
}

export default BookingTitle;
